// GERADO — não editar à mão. O gerador (`build_landings.py`, spec-007) NÃO está
// versionado neste repo: `git ls-files | grep .specify` volta vazio. Ele vive no
// workspace de spec-kit do autor da spec-007 (@Jgabrieljohn) — pedir a ele antes
// de qualquer regeração em massa deste mapa ou dos HTML de public/servicos/.
// Enquanto isso, a deriva mapa x HTML é travada por `tests/unit/servicos-landing.unit.js`.
// id_solicitacao_tipo (uuid5 determinístico do `codigo`) -> slug da landing
// estática em public/servicos/. Estável entre dev e prod: o uuid5 deriva do
// codigo do catálogo, não de sequence.
export const LANDING_SLUGS = {
  '94531547-cf1e-57f3-8ee2-c51b0e2c6db6': 'alteracoes-contratuais',
  '2a857592-5623-5941-a492-79f66c26d90f': 'app-mobile-white-label',
  'e275303f-cfde-5be5-a094-3c1e24b6efe3': 'apresentacoes-material-institucional',
  'a1a15f77-f99c-52b8-86ab-6587e817f1b9': 'assessoria-m-a-originacao-sell-buy-side',
  'cf22709f-7950-58f4-ba99-6955c87bb7ae': 'back-office-operacao',
  'b463c016-c97d-5f09-8f71-bee947ec29c5': 'bi-gestao',
  '50097004-84ea-50cf-8d76-21bfe2e25091': 'board-advisory-comites',
  '7c393b34-6968-5933-a878-543856b59ef5': 'bpo-comissionamento',
  'eead9767-29c7-5116-b347-76960fe3576a': 'bpo-contabilidade',
  '0ba60243-18b4-55da-8425-dadf2ab45c75': 'bpo-controladoria',
  'bd649d4a-55f3-5a0d-a33b-5f77453e4acf': 'bpo-tesouraria',
  'c1f87f6b-553f-5aac-ad57-a17b38a4616b': 'business-plan-pitch-de-corretora',
  '85f07edb-8e51-5f2c-b1b4-785e4648215e': 'change-management',
  'd825f115-2330-5332-bd0c-6e718b2e464e': 'cobranca-operacao',
  '69361e52-262b-5933-b82c-8364077ca640': 'comissionamento-gestao',
  'd8163eee-2f21-5204-a5e7-07e626b40350': 'compliance-operacao',
  'fa328b1a-990e-5c39-bcae-455ce9c95242': 'compra-venda-de-carteira-de-ais',
  'b8186dc9-fa69-5a3a-8321-f6e352b9dfd0': 'consolidacao-de-carteiras-cotizacao',
  'b3648ea9-cb09-530b-a6c9-652f3e1110c1': 'consolidador-operacao',
  '584a2c2d-9e36-500a-b568-17104f7c1060': 'constituicao-abertura-de-pj-cvm',
  '5b510a6c-c3a9-5371-a685-fbe51e47d1f0': 'constituicao-de-holding-patrimonial',
  '6689273b-af8f-5da2-ab6c-67011af9d05e': 'consultoria-cvm-estruturacao-completa',
  '4b51f3c7-d4ec-5c9b-b467-c9b280110530': 'consultoria-cvm-registro-juridico',
  '559e7875-2e28-5f56-92d7-dd6d0e0b9a76': 'consultoria-estrategica-modelo-de-negocio',
  '999dbd86-bc6c-50ef-a08d-c95fff6f7e0e': 'contencioso-acompanhamento-de-processos-judiciais',
  '5d069451-73c1-530c-b5bf-1d071035a41c': 'contratos-comerciais-cliente-final',
  '3107d093-f58c-52ce-bb31-05d15b47124e': 'controladoria-gestao',
  '7b98c5bc-06a2-5cb2-9dbe-57c6641b0c16': 'crm-operacao',
  'bb1a946f-d401-5e95-84a0-9cff63bf3d18': 'diagnostico-nivelamento-financeiro',
  'd9feaa14-62b1-56fb-a478-d1fe15fb5ffb': 'due-diligence-standalone',
  'b89ecff3-3512-5faa-ad96-9cc2be3f5359': 'emissao-de-informes-de-rendimentos-apoio-ir',
  '4fec78c7-d466-5bdb-abbd-8b166829d870': 'encerramento-de-filial-baixa-de-pj',
  '0de7870a-da35-5982-9597-27c831bc83ff': 'estrategia-de-liquidez',
  '3407c48e-8530-5ebd-8543-43f64c6af6f4': 'estrutura-contratual-acordo-de-socios',
  '63f6ddb9-7266-580b-b045-9adaf890ad13': 'estruturacao-de-partnership',
  'eb7e648e-5153-51e5-b360-dd6e9e66de8a': 'financial-planning-operacao',
  'b8fabc56-a4d1-549a-893e-77b9deab9b97': 'gestao-de-desempenho-gestao',
  '257da712-3b68-545e-8bd8-533a169cf1d6': 'gestao-de-performance',
  'e4174d47-34a7-5444-a40b-5c245e3fc507': 'gestao-estrategia-comercial',
  'af27ed2b-4539-5456-8fe8-a6f2253f3b3a': 'governanca-cybersecurity',
  '7feaf56f-a1ce-5b86-8a99-d44beb439c99': 'implementacao-de-erp-financeiro',
  'a90aead2-3717-56ac-8740-41ef6f22d04e': 'integracao-api-sso',
  '056f7eb0-1dba-5ea9-8396-dca23d1773c0': 'lancamento-go-to-market',
  '27fa255a-b69a-5f22-8863-97c56bce7737': 'lgpd-politicas-de-privacidade',
  '27d11966-cef7-5e3b-b8bd-0ad838251411': 'livros-atas-societarias',
  'c0301a2d-976e-5a77-ae0d-8bc91b41454b': 'marca-identidade-visual',
  '104147a3-cd68-5ca6-b19d-bb059cac298f': 'melhorias-de-plataforma',
  'c797bc05-c539-50de-9f7d-d92418966561': 'mesa-proprietaria-estrutura-de-compensacao',
  'f3e64b7e-159b-5f12-b6d0-59b725904a5d': 'modelo-de-atracao-de-profissionais-ais',
  '5490bab6-2121-59b8-bfa0-310428023c93': 'naming-validacao-de-nome',
  'adcc527e-3975-558e-ba53-88e6eb15b371': 'negociacao-de-contrato-de-distribuicao',
  '053cfbc0-47c5-5ef4-91d6-5d159b3f8e65': 'obrigacoes-acessorias-compliance-tributario',
  'f417eb1e-fd03-5c2d-9b1c-b383b7d90078': 'onboarding-offboarding-de-ais',
  'bf270b46-88c5-57ec-96f0-3e4e7bf9289d': 'onboarding-parametrizacao-plataforma-hub',
  '15987d59-8ff3-5455-89a7-7a8e3e5d2974': 'partnership-gestao-de-contratos-gestao',
  'e8dc6c51-4cab-5df7-a2cc-5c392a424f25': 'planejamento-orcamentario',
  '1f179406-1922-5ccc-b7e8-5d0959f4d98c': 'planejamento-sucessorio-patrimonial',
  'd8de8787-5c65-5c5f-a42b-1915350faf50': 'plano-de-carreira-incentivos',
  '97c37318-5651-5ff2-a2b5-655176219caf': 'plano-de-mkt-social-media',
  '4537d227-3b76-5229-822c-6728f5ec911c': 'portfolio-review-operacao',
  'b46778d7-ff27-590c-a09a-29ed3320eda3': 'processo-de-expansao-de-profissionais',
  '7bf12fd7-8145-502f-94a1-315e18196648': 'processo-de-onboarding-e-avaliacao-de-desempenho',
  'cabee929-e378-5a5e-b1e4-d8103e524eb4': 'processo-de-selecao-e-contratacao-de-profissionais',
  'd232f860-9a70-5b15-a54a-9369eaad51e3': 'relatorios-dashboards',
  '57fb1908-2140-519f-8783-fdcb6dd23cdd': 'setup-digital',
  '9ac55e90-4925-5d69-ae9d-6de598209c14': 'site-landing-page',
  '2ec3be7e-88dd-5dd3-b4b3-f3ec3f8871c5': 'valuation-modelagem-laudo',
  'b0fc031c-5abe-5b8c-a8e1-b1d28da60ead': 'vinculacao-juridica-com-ws-corretora',
}
